import styled from 'styled-components'
import { t } from 'ttag'

import { Heading } from '@h2/components/typography/heading'
import { Flex } from '@h2/components/layout/flex'
import { Text } from '@h2/components/typography/text'

const Wrap = styled.div`
  margin-top: 15px;

  > :nth-child(3) {
    > div {
      width: calc(33% - 10px);
    }
  }
`
const KeyStatistics = ({ children }) => (
  <Wrap>
    <Flex margin="0 0 5px 5px">
      <Heading level="5" removeMargins={true}>
        {t`Key `}
        <strong>{t`statistics`}</strong>
      </Heading>
    </Flex>
    <Flex margin="0 0 5px 5px">
      <Text size="medium" margin="0">
        {t`Statistics are generated for the current program year.`}
      </Text>
    </Flex>
    <Flex wrap="wrap" justifyContent="space-between" gap="10px">
      {children}
    </Flex>
  </Wrap>
)

export { KeyStatistics }
